import { PERMANENT_CROP_KEYWORDS } from './context.js';
export function parseDateRobust(dateStr) {
    if (!dateStr) return null;
    
    // Formato ISO: YYYY-MM-DD
    if (/^\d{4}-\d{2}-\d{2}/.test(dateStr)) {
        const parts = dateStr.substring(0, 10).split('-');
        return new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
    }
    
    // Formato Italiano: DD/MM/YYYY
    if (/^\d{2}\/\d{2}\/\d{4}/.test(dateStr)) {
        const parts = dateStr.split('/');
        return new Date(parseInt(parts[2], 10), parseInt(parts[1], 10) - 1, parseInt(parts[0], 10));
    }
    
    const parsed = new Date(dateStr);
    if (!isNaN(parsed.getTime())) return parsed;
    
    return null;
}
export function calculatePolygonArea(coords) {
    const earthRadius = 6378137; // in meters
    let area = 0;
    
    if (coords.length > 2) {
        for (let i = 0; i < coords.length; i++) {
            let p1 = coords[i];
            let p2 = coords[(i + 1) % coords.length];
            // latitude/longitude in radians
            let lat1 = p1[0] * Math.PI / 180;
            let lat2 = p2[0] * Math.PI / 180;
            let lon1 = p1[1] * Math.PI / 180;
            let lon2 = p2[1] * Math.PI / 180;
            
            area += (lon2 - lon1) * (2 + Math.sin(lat1) + Math.sin(lat2));
        }
        area = area * earthRadius * earthRadius / 2;
    }
    
    const areaSqMeters = Math.abs(area);
    return areaSqMeters / 10000; // convert to hectares
}
export function checkParticelleContiguita(particelleStr) {
    const parts = particelleStr.split(/[,;]/).map(p => p.trim()).filter(Boolean);
    if (parts.length <= 1) {
        return { isValid: true, expanded: parts };
    }

    const expandedParts = [];
    for (const part of parts) {
        const rangeMatch = part.match(/^(\d+)-(\d+)$/);
        if (rangeMatch) {
            const start = parseInt(rangeMatch[1], 10);
            const end = parseInt(rangeMatch[2], 10);
            if (start < end && end - start < 100) {
                for (let i = start; i <= end; i++) {
                    expandedParts.push(String(i));
                }
            } else {
                expandedParts.push(part);
            }
        } else {
            expandedParts.push(part);
        }
    }

    const parsed = expandedParts.map(part => {
        const match = part.match(/^(\d+)(.*)$/);
        if (match) {
            return {
                original: part,
                base: parseInt(match[1], 10),
                suffix: match[2].trim().toLowerCase()
            };
        } else {
            return {
                original: part,
                base: NaN,
                suffix: part.toLowerCase()
            };
        }
    });

    if (parsed.some(p => isNaN(p.base))) {
        return { isValid: false, reason: 'Formato particelle non valido (usa numeri separati da virgole o trattini, es: 10, 11, 10bis)', expanded: expandedParts };
    }

    parsed.sort((a, b) => a.base - b.base);

    for (let i = 0; i < parsed.length - 1; i++) {
        const current = parsed[i];
        const next = parsed[i + 1];
        const diff = next.base - current.base;
        if (diff !== 0 && diff !== 1) {
            return { 
                isValid: false, 
                reason: `Le particelle ${current.original} e ${next.original} non sono consecutive/contigue.`,
                expanded: expandedParts
            };
        }
    }

    return { isValid: true, expanded: expandedParts };
}
export function activityMatchesField(activity, field) {
    if (!activity || !field) return false;
    if (activity.fieldId && activity.fieldId === field.id) return true;
    if (activity.fieldName && activity.fieldName === field.name) return true;
    return false;
}
export function formatActivityTypeLabel(type) {
    const labels = {
        trattamento: 'Trattamento',
        lavorazione: 'Lavorazione',
        concimazione: 'Concimazione',
        semina: 'Semina / Trapianto',
        irrigazione: 'Irrigazione',
        raccolta: 'Raccolta'
    };
    return labels[(type || '').toLowerCase()] || (type ? type.charAt(0).toUpperCase() + type.slice(1) : 'Attività');
}
export function getActivityCrop(activity) {
    const field = (C.state.fields || []).find(f => f.id === activity.fieldId);
    return field?.crop || activity.fieldCrop || '';
}
export function getFieldAreaFormatted(fieldId) {
    const f = C.state.fields.find(field => field.id === fieldId);
    return f ? `${f.area.toFixed(2)} ha` : '-';
}

export function getUnitForProduct(productName) {
    const p = C.state.inventory.find(prod => prod.name.toLowerCase() === productName.toLowerCase());
    return p ? p.unit : 'kg';
}

export function getSafetyStatusBadge(expiryDateStr) {
    if (expiryDateStr === 'Nessuno') {
        return `<span class="badge badge-success">Nessuna carenza</span>`;
    }

    const expiry = new Date(expiryDateStr);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (expiry >= today) {
        const daysLeft = Math.ceil((expiry - today) / (1000 * 60 * 60 * 24));
        return `<span class="badge badge-danger">In Carenza (${daysLeft}gg residui)</span>`;
    } else {
        return `<span class="badge badge-success">Carenza Scaduta (OK)</span>`;
    }
}

export function formatDate(dateStr) {
    const d = new Date(dateStr);
    return d.toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' });
}
export function isPermanentCrop(crop) {
    if (!crop) return false;
    return PERMANENT_CROP_KEYWORDS.some(k => crop.toLowerCase().includes(k));
}

export function formatDateIT(dateStr) {
    if (!dateStr) return '';
    const [y, m, d] = dateStr.split('-');
    return `${d}/${m}/${y}`;
}